import React from "react";

export interface IconProps {
  className?: string;
  size?: number;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export interface BaseIconProps extends IconProps {
  children: React.ReactNode;
  viewBox?: string;
}

const Icon: React.FC<BaseIconProps> = ({
  children,
  className = "",
  size,
  width,
  height,
  style,
  viewBox = "0 0 24 24",
}) => {
  const finalWidth = width || size || 24;
  const finalHeight = height || size || 24;

  return (
    <svg
      className={className}
      style={style}
      fill="none"
      stroke="currentColor"
      viewBox={viewBox}
      width={finalWidth}
      height={finalHeight}
      aria-hidden="true"
    >
      {children}
    </svg>
  );
};

export default Icon;
